package com.util.rsvp

import kotlinx.serialization.Serializable

@Serializable
enum class ReadingMode {
    Focus,
    Guided,
}

